export default {"src":"/_next/static/media/premium-expansion-sweden-icon.36a4347c.svg","height":50,"width":50,"blurWidth":0,"blurHeight":0};